<div class="card">
  <div class="card-body">
    <h5>{{'DANH SÁCH CỬA HÀNG' | translate}}</h5>
    <div class="row">
      <div class="flex-fill row">
        <div class="col-3">
          <div class="form-group">
            <label for="validationCustom01">{{'Mã cửa hàng' | translate}}</label>
            <input type="text" class="form-control" [(ngModel)]="filter.code"
              placeholder="{{'Nhập mã cửa hàng' | translate}}" />
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label for="validationCustom01">{{'Terminal ID' | translate}}</label>
            <input type="text" class="form-control" [(ngModel)]="filter.terminalID"
              placeholder="{{'Nhập Terminal ID' | translate}}" />
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label for="validationCustom01">{{'Số tài khoản' | translate}}</label>
            <input type="text" class="form-control" [(ngModel)]="filter.terminalBankAcc"
              placeholder="{{'Nhập số tài khoản' | translate}}" />
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label for="validationCustom01">{{'Loại cửa hàng' | translate}}</label>
            <ng-select [(ngModel)]="filter.customerType" [clearable]="true">
              <ng-option value="">{{'Tất cả' | translate}}</ng-option>
              <ng-option value="CN">{{'Cá nhân' | translate}}</ng-option>
              <ng-option value="HKD">{{'Hộ kinh doanh' | translate}}</ng-option>
              <ng-option value="DN">{{'Doanh nghiệp' | translate}}</ng-option>
              <ng-option value="DN-HKD">{{'Doanh nghiệp - Hộ kinh doanh' | translate}}</ng-option>
            </ng-select>
          </div>
        </div>
        <div class="col-3">
          <div style="min-width: 200px;">
            <div class="form-group">
              <label for="validationCustom01" class="d-block">&nbsp;</label>
              <button class="btn btn-primary btnall" (click)="submitFilter()">
                {{'PAGE.REPORT.Search' | translate}}
              </button>
              <button class="btn btn-dark ml-2" *ngIf="searching" (click)="clearFilter()">
                {{'FORM.Clear' | translate}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-md-2"></div>
    <div class="table-responsive">
      <table id="basic-datatable" class="table table-bordered dt-responsive nowrap no-footer dtr-inline workspace-table">
        <colgroup>
          <col style="width: 50px" />
          <col style="width: 110px" />
          <col style="width: 150px" />
          <col style="width: 180px" />
          <col style="width: 180px" />
          <col style="width: 150px" />
          <col style="width: 180px" />
          <col style="width: 100px" />
          <col style="width: 100px" />
          <col style="width: 120px" />
        </colgroup>
        <thead>
          <tr class="text-center bg-table">
            <th>{{'#' | translate}}</th>
            <th>{{'Mã cửa hàng' | translate}}</th>
            <th>{{'Terminal ID' | translate}}</th>
            <th>{{'Chủ cửa hàng' | translate}}</th>
            <th>{{'Tên cửa hàng' | translate}}</th>
            <th>{{'Số tài khoản' | translate}}</th>
            <th>{{'Chủ tài khoản' | translate}}</th>
            <th>{{'Loại cửa hàng' | translate}}</th>
            <th>{{'Loại QR' | translate}}</th>
            <th>{{'Ngày tạo' | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr class="text-center" *ngFor="let data of listData;let i=index">
            <td>
              <a>{{pageSize*(pageIndex-1) +i+1}}</a>
            </td>
            <td><a>{{data.code}}</a></td>
            <td><a>{{data.terminalID}}</a></td>
            <td><a>{{data.leader}}</a></td>
            <td><a>{{data.name}}</a></td>
            <td><a>{{data.terminal_bank_acc}}</a></td>
            <td><a>{{data.terminal_bank_acc_name}}</a></td>
            <td>
              <span
                *ngIf="
                  data.customer_type === 'CN' ||
                    data.customer_type === 'HKD' ||
                    data.customer_type === 'DN' ||
                    data.customer_type === 'DN-HKD';
                  else customerTypeDefault
                "
                class="badge font-size-12"
                [ngClass]="{
                  'badge-info': data.customer_type === 'CN',
                  'badge-primary': data.customer_type === 'HKD',
                  'badge-warning': data.customer_type === 'DN',
                  'badge-success': data.customer_type === 'DN-HKD'
                }"
              >
                {{ data.customer_type }}
              </span>
              <ng-template #customerTypeDefault>{{
                data.customer_type
              }}</ng-template>
            </td>
            <td>
              <span
                class="badge badge-secondary font-size-12"
                *ngIf="data.qr_type == 0; else qrAnonymous"
                >QR thường</span
              >
              <ng-template #qrAnonymous>
                <span class="badge badge-primary font-size-12">QR vô danh</span>
              </ng-template>
            </td>
            <td>
              <a>{{data.created_at | date:'dd/MM/yyyy HH:mm'}}</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row justify-content-md-between align-items-md-center mt-2">
      <div class="col-sm-12 col-md-5">
        <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite">
          {{'TABLE.Showing' | translate}} {{pageSize*pageIndex - pageSize + 1}}
          {{'TABLE.to' | translate}} {{pageSize*pageIndex}} {{'TABLE.of' |
          translate}} {{totalCount}} {{'TABLE.entries' | translate}}
        </div>
      </div>
      <!-- Pagination -->
      <div class="col-sm-12 col-md-5 d-flex align-items-center justify-content-end">
        <div class="text-md-right float-md-right pagination-rounded">
          <ngb-pagination [collectionSize]="totalCount" [(page)]="pageIndex" [pageSize]="pageSize" [maxSize]="5"
            [ellipses]="true" (pageChange)="fetchData()">
          </ngb-pagination>
        </div>
        <div class="dataTables_length ml-3" id="tickets-table_length">
          <label class="d-inline-flex align-items-center mb-0">
            {{'TABLE.Show' | translate}}
            <select name="tickets-table_length" aria-controls="tickets-table" name="pageSize" [(ngModel)]="pageSize"
              (ngModelChange)="pageIndex = 1;fetchData()"
              class="custom-select custom-select-sm form-control form-control-sm mx-2">
              <option [ngValue]="10">10</option>
              <option [ngValue]="25">25</option>
              <option [ngValue]="50">50</option>
              <option [ngValue]="100">100</option>
            </select>
            {{'TABLE.entries' | translate}}
          </label>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #content role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ formData.value.id ? "FORM.Edit" : "Thêm cửa hàng" | translate }}
    </h5>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="saveData()" [formGroup]="formData">
        <div class="row">
          <div class="row m-0 p-0">
            <div class="form-group col-12">
              <label class="col-5 col-form-label required_label">{{ 'Người dùng' | translate }}</label>
              <ng-select formControlName="userId" class="form-select" aria-label="Default select example"
                class="col-md-12">
                <ng-option [value]="" hidden>Chọn người dùng</ng-option>
                <ng-option value="{{item.id}}" *ngFor="let item of listDataUser">
                  {{ item.id }} - {{ item.full_name }} - {{ item.phone }}
                </ng-option>
              </ng-select>
            </div>
            <div class="form-group col-12">
              <label class="col-5 col-form-label required_label">{{ 'Tên cửa hàng' | translate }}</label>
              <div class="col-12">
                <input type="text" class="form-control" formControlName="name" />
              </div>
            </div>
            <div class="form-group col-12">
              <label class="col-5 col-form-label required_label">{{ 'Địa chỉ' | translate }}</label>
              <div class="col-12">
                <input type="text" class="form-control" formControlName="terminalAddress" />
              </div>
            </div>
            <div class="form-group col-12">
              <label class="col-5 col-form-label required_label">{{ 'Ngân hàng' | translate }}</label>
              <ng-select formControlName="binNumber" class="form-select" aria-label="Default select example"
                class="col-md-12">
                <ng-option [value]="" hidden>Chọn ngân hàng</ng-option>
                <ng-option value="{{item.id}}" *ngFor="let item of listBankname">{{ item.name }}</ng-option>
              </ng-select>
            </div>
            <div class="form-group col-12">
              <label class="col-5 col-form-label required_label">{{ 'Số tài khoản' | translate }}</label>
              <div class="col-12">
                <input type="text" class="form-control" formControlName="accountNumber" [(ngModel)]="accountNumber"
                  (blur)="onInputBlur()" />
              </div>
            </div>
            <span class="text-danger font-italic font-size-12" *ngIf="!searching">
              Cần nhập tài khoản ngân hàng để thêm cửa hàng
            </span>

            <div class="form-group col-12" *ngIf="searching">
              <label class="col-5 col-form-label required_label">{{ 'Chủ tài khoản' | translate }}</label>
              <div class="col-12">
                <input type="text" [ngModel]="bank_accountName" formControlName="terminalBankAccountName"
                  class="form-control" readonly />
              </div>
            </div>
          </div>
        </div>
        <div class="text-center" *ngIf="searching">
          <button type="button" class="btn btn-secondary btn-lg mr-3" style="width: 150px;"
            (click)="modal('close click')">
            {{ 'Đóng' | translate }}
          </button>
          <button type="submit" class="btn btn-success btn-lg" style="width: 150px;">
            {{ 'Lưu' | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #contentLink role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">
      {{"Liên kết thiết bị và tài khoản" | translate}}
    </h5>
    <!-- <div *ngIf="makeForm('password').hasError('required')" class="error-message">
            Mật khẩu không được bỏ trống.
        </div> -->
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="saveData2()" [formGroup]="formData2">
        <div class="row">
          <div class="form-group row col-md-12">
            <div class="col mt-3">
              <div class="d-flex">
                <label class="col-md-4 col-form-label required_label">{{'Thiết bị' |translate}}</label>
                <div class="col-md-8">
                  <ng-select formControlName="device_id">
                    <ng-option [value]="-1">Chọn thiết bị</ng-option>
                    <ng-option [value]="item.device_id" *ngFor="let item of listData2">
                      {{item.serial_number}}</ng-option>
                  </ng-select>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group row col-md-12">
            <div class="col mt-3">
              <div class="d-flex">
                <label class="col-md-4 col-form-label required_label">{{'Tài khoản' |translate}}</label>
                <div class="col-md-8">
                  <ng-select formControlName="bankaccount_id">
                    <ng-option [value]="-1">Chọn tài khoản</ng-option>
                    <ng-option [value]="item.bankaccount_id" *ngFor="let item of listData3">
                      {{item.account_number}} - {{item.bank_account_name}} -
                      {{item.bank_name}}</ng-option>
                  </ng-select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="text-right">
                    <button type="button" class="btn btn-secondary btn-sm mr-3"
                        (click)="modal('close click')">{{'Đóng' | translate}}</button>
                    <button type="submit" class="btn btn-primary btn-sm">{{'Lưu' | translate}}</button>
                </div> -->
        <div class="text-center">
          <button type="button" class="btn btn-secondary btn-lg mr-3" style="width: 150px;"
            (click)="modal('close click')">
            {{'Đóng' | translate}}
          </button>
          <button type="submit" class="btn btn-success btn-lg" style="width: 150px;">
            {{'Lưu' | translate}}
          </button>
          <!-- <button type="button" class="btn btn-secondary btn-sm" style="width: 150px"
                    (click)="modal('close click')">{{'FORM.Close' | translate}}</button>
                <button type="button" class="btn btn-primary btn-sm ml-3" style="width: 150px"
                    (click)="updateFormNote()">{{'FORM.Save' | translate}}</button> -->
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #contentKeyword let-modalHis="close">
  <div class="modal-header">
    <h5 class="modal-title">List keyword of "{{selectedIncident.name}}"</h5>
    <button type="button" class="close" aria-label="Close" (click)="modalHis('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="mb-3" *ngIf="formNewKeyword">
      <h5 class="font-size-14">Add New Keyword</h5>
      <form [formGroup]="formNewKeyword" (submit)="onSubmitFormKeyword(2)" class="d-flex">
        <input type="text" class="form-control form-control-sm" style="width: 250px;" formControlName="name" />
        <button class="btn btn-primary btn-sm ml-3" style="width: 150px;">
          Add
        </button>
      </form>
    </div>
    <div class="table-responsive">
      <table id="basic-datatable" class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
        <thead>
          <tr>
            <th width="50">#</th>
            <th>Name</th>
            <!-- <th>Thời gian</th> -->
            <th width="170"></th>
          </tr>
        </thead>
        <tbody *ngFor="let data of dataKeyword;let i=index">
          <tr>
            <td>{{i+1}}</td>
            <td>
              <ng-container *ngIf="selectedKeyword?.id == data.id && formEditKeyword; else normal">
                <form [formGroup]="formEditKeyword" (submit)="onSubmitFormKeyword(1)">
                  <input type="text" class="form-control form-control-sm" formControlName="name" />
                </form>
              </ng-container>
              <ng-template #normal>{{data.name}}</ng-template>
            </td>
            <!-- <td>{{data.created_at*1000 | date:'dd/MM/yyyy HH:mm'}}</td> -->
            <td>
              <div class="d-flex" style="gap: 10px;">
                <a class="btn btn-sm btn-success" href="javascript: void(0);" (click)="editKeyword(data,i)">
                  <i class="mdi mdi-account-edit"></i>{{'FORM.Edit' |
                  translate}}</a>
                <a class="text-white btn btn-sm btn-danger" (click)="onDeleteKeyword(data.id)"><i
                    class="mdi mdi-delete"></i>{{'FORM.Delete' |
                  translate}}</a>
              </div>
              <!-- <button class="btn" (click)="editKeyword(data,i)">Sửa</button>
                            <button>Xoá</button> -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>